<template>
<div>
    <b-input-group size="sm">
        <b-form-select :options="gradeOptions"
                        :state="componentCondition.grade && componentCondition.grade.length ? null : false"
                        @change="updateCondition()"
                        v-model="componentCondition.grade">
            <template #first>
                <b-form-select-option :value="null" disabled>Grade</b-form-select-option>
            </template>
        </b-form-select>
        <b-form-select :options="conditionSubjectOptions"
                        v-model="componentCondition.subject"
                        @change="updateCondition()"
                        :state="componentCondition.subject && componentCondition.subject.length ? null : false">

            <template #first>
                <b-form-select-option :value="null" disabled>Subject</b-form-select-option>
            </template>
        </b-form-select>

        <b-input-group-append>
            <b-button size="sm" variant="outline-secondary" @click="removeCondition" tabindex="-1">
                <b-icon-x></b-icon-x>
            </b-button>
        </b-input-group-append>
    </b-input-group>


    <b-form-tags v-model="componentCondition.notes"
                    size="sm"
                    placeholder=""
                    no-outer-focus
                    separator=","
                    remove-on-delete>

        <template v-slot="{ tags, inputAttrs, inputHandlers, removeTag }">

            <b-input-group size="sm">
                <drop @drop="dropCondition($event)" style="width: 100%">
                    <input v-bind="inputAttrs"
                            v-on="inputHandlers"
                            placeholder="Notes"
                            class="form-control drop-input">
                </drop>
            </b-input-group>

            <ul class="list-unstyled d-inline-flex flex-wrap mb-0">
                <b-card v-for="tag in tags" :key="tag" size="sm"
                        class="mt-1 mr-1"
                        body-class="py-0 pr-2">
                    <span>{{ tag }}</span>
                    <b-button variant="link" class="pt-1 pb-1 text-secondary" @click="removeTag(tag)" tabindex="-1">
                        <b-icon-x-square></b-icon-x-square>
                    </b-button>
                </b-card>
            </ul>

        </template>
    </b-form-tags>    
</div>
</template>



<script>
import conditionSubjectOptions from "../../assets/conditionSubjectOptions";
import conditionGradeOptions from "../../assets/conditionGradeOptions";

    export default {
        name: "Condition",
        props: [ 'condition', 'mediaType', 'fillSubject', 'mediaSpeed', 'mediaSize' ],
        mixins: [ conditionSubjectOptions, conditionGradeOptions ],
        async created() {
            this.componentCondition = this.condition;
            this.autoFillSubject();
            this.gradeOptions = this.mediaSpeed === '78' && this.mediaSize === '10' ? this.conditionGrades78 : this.conditionGrades;
            console.log(this.componentCondition);
        },
        mounted() {
            // console.log('Condition mounted with speed:', this.speed);
        },
        data() {
            return {
                componentCondition: null,
                gradeOptions: [],
            }
        },
        methods: {
            removeCondition() {
                this.$emit('removeCondition');
            },
            updateCondition() {
                this.$emit('updateCondition', this.componentCondition)
            },
            dropCondition(event) {
                this.$emit('dropConditionNote', event);
            },
            autoFillSubject() {
                if (this.fillSubject) {
                    const subject = this.mediaType && (this.mediaType === "Cassette" || this.mediaType === "Cassette Single") ? 'cassette' : 'disc';
                    this.$set(this.componentCondition, 'subject', subject);
                }
            }

        },
        watch: {
            mediaType(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.autoFillSubject();
                    console.log('mediaType changed from', oldValue, 'to', newValue);
                }
            },
            mediaSize(newValue, oldValue) {
                console.log('mediaSize changed from', oldValue, 'to', newValue);
                console.log('mediaSpeed', this.mediaSpeed);
                if (newValue === '10' && this.mediaSpeed === '78') {
                    this.gradeOptions = this.conditionGrades78;
                } else {
                    this.gradeOptions = this.conditionGrades;
                }
            },
            mediaSpeed(newValue, oldValue) {
                console.log('Speed watcher triggered:', { oldValue, newValue });
                if (newValue) {
                    console.log('Speed updated to:', newValue);
                    // Add your speed-related logic here
                    console.log(`componentCondition: ${this.componentCondition.grade}`);
                    if (newValue === '78' && this.mediaSize === '10') {
                        this.gradeOptions = this.conditionGrades78;
                    } else {
                        this.gradeOptions = this.conditionGrades;
                    }
                }
            }
        
        }
    }
</script>

<style scoped>

</style>